export const frontmatter = {
    "draft": true,
    "title": "MCPs",
    "description": "Model Context Protocol: connect OnnIA agents with external tools.",
    "sidebar_label": "MCPs",
    "sidebar_group": "guides",
    "sidebar_order": 6
}

export const toc = []